import I18n from 'i18n-js';

window.I18n = I18n;

require('./translations');

I18n.locale = document.documentElement.lang;

export default I18n;
